import React from 'react';
import Tile from './Tile';
import { AnimatePresence } from 'framer-motion';

const Board = ({ grid }) => {
  const tiles = [];
  grid.forEach((row, r) => {
    row.forEach((tile, c) => {
      if (tile) {
        tiles.push({
          ...tile,
          r,
          c
        });
      }
    });
  });

  return (
    <div className="relative pointer-events-none">
      {/* 背景方格 */}
      <div className="game-grid pointer-events-auto">
        {Array(16).fill(null).map((_, i) => (
          <div key={i} className="grid-cell" />
        ))}
      </div>

      {/* 方塊層 */}
      <div className="absolute inset-0 z-10">
        <AnimatePresence mode="sync">
          {tiles.map((tile) => (
            <Tile 
              key={tile.id} 
              value={tile.value} 
              r={tile.r} 
              c={tile.c}
              isMerged={tile.isMerged}
              isNew={tile.isNew}
            />
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Board;